// extracted by mini-css-extract-plugin
module.exports = {"userScoreWrapper":"UserScore_userScoreWrapper__19iqs","userScoreInnerContainer":"UserScore_userScoreInnerContainer__2kUPt"};